import React from 'react';

const Title: React.FC = ({ children }) => (
  <div className="change-email-modal--title">{children}</div>
);

export default Title;
